import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "small" }
const _hoisted_4 = { class: "small me-3 text-end" }
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = { class: "small me-3 text-end" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "fw-bold"
}
const _hoisted_9 = { class: "btn-group btn-group-sm me-2" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "container-fluid p-0 overflow-scroll mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_team_breadcrumbs = _resolveComponent("my-team-breadcrumbs")!
  const _component_my_team_sort_pills = _resolveComponent("my-team-sort-pills")!
  const _component_my_team_table = _resolveComponent("my-team-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_my_team_breadcrumbs),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[1] || (_cache[1] = _createTextVNode(" Miembros: ", -1)),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.teamMembers?.length || 0), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[2] || (_cache[2] = _createTextVNode(" Actualizado: ", -1)),
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, " - "))
              : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.formatDateTimezone(_ctx.teamMembers ? _ctx.teamMembers[0]?._updated_date : 0)), 1))
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "btn btn-outline-secondary",
              disabled: _ctx.isLoading,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refresh())),
              title: "Actualizar"
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("i", { class: "fas fa-redo" }, null, -1)
            ]))], 8, _hoisted_10)
          ])
        ])
      ])
    ]),
    (_ctx.getSortConfiguration.length > 0)
      ? (_openBlock(), _createBlock(_component_my_team_sort_pills, {
          key: 0,
          onUpdateSortConfiguration: _ctx.updateSortConfiguration
        }, null, 8, ["onUpdateSortConfiguration"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_my_team_table, { onUpdateSortConfiguration: _ctx.updateSortConfiguration }, null, 8, ["onUpdateSortConfiguration"])
    ])
  ], 64))
}